export enum SPORT_MENUS {
  LIVE = 'live',
  PREMATCH = 'prematch',
}
